import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { updateObject } from '../../global/utility';

import * as billboardActions from '../actions/index';
import * as userActions from '../../global/user/actions/index';

import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import Button from '../../global/button/button';
import TextField from '../../global/text_field/text_field';
import logger from '../../global/logger';

class BillboardDeviceEditView extends Component {

    state = {
        code: "",
    }

    componentDidMount() {
        this.props.onSelectDeviceByID(this.props.match.params.id);
        // this.props.onFetchUserDetails(this.props.match.params.id);
        // this.props.onFetchCurrentUserPermissions();
        logger.log(this.props.match.params.id);
        // this.setState(updateObject(this.state, {code: this.props.selected_device.pairing_code}));
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.onSelectDeviceByID(this.props.match.params.id);
            // this.props.onFetchUserDetails(this.props.match.params.id);
            // this.props.onFetchCurrentUserPermissions();
            logger.log(this.props.match.params.id);
            // this.setState(updateObject(this.state, {selectedPlanId: null}));
            this.setState(updateObject(this.state, {code: this.props.selected_device.pairing_code}));
        }
    }

    deleteDevice() {
        this.props.onDeleteDevice(this.props.selected_device.id);
    }

    onPlaylistChange(event) {
        const value = event.target.value;
        const playlist_id = value === "" ? null : parseInt(value, 10);
        this.props.onUpdateDevice(this.props.selected_device.id, { billboard_playlist_id: playlist_id });
    }


    componentWillUnmount() {
        
    }

    changeHandler(event, property_name) {
        
        this.setState(updateObject(this.state, {code: event.target.value}));
        logger.log("message: " + this.state.code);
    }


    render() {
        
        const { path } = this.props.match;
        
        if (this.props.selected_device == null) {
            return <div><p>No device selected</p></div>
        }

        const assignedPlaylistId = this.props.selected_device.billboard_playlist_id;

        let content = (
            <div>
                <p className="text-gray-500 text-xl mb-2">{this.props.selected_device.title}</p>
                <br />
                <p className="text-gray-500 text-sm mb-2">Pairing Code: {this.props.selected_device.pairing_code}</p>
                <br />

                <label className="block text-sm font-medium text-gray-500 mb-1">Assigned Playlist</label>
                <select
                    value={assignedPlaylistId == null ? "" : assignedPlaylistId}
                    onChange={(e) => this.onPlaylistChange(e)}
                    disabled={this.props.updating_device}
                    className="w-full border border-gray-300 rounded-sm px-3 py-2 text-sm focus:outline-hidden focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 mb-4"
                >
                    <option value="">No playlist assigned</option>
                    {(this.props.playlists || []).map(playlist => (
                        <option key={playlist.id} value={playlist.id}>{playlist.title}</option>
                    ))}
                </select>

                <Button id="delete_device" width="w-full" text="Delete Device" clickEvent={() => this.deleteDevice()} />

            </div>
        );

        if (this.props.loading_devices) {
            content = (
                <LoadingIndicator />
            )
        }

        return content;
    }
}

const mapStateToProps = state => {
    return {
        loading_devices: state.billboard.loading_devices,
        selected_device: state.billboard.selected_device,
        playlists: state.billboard.playlists,
        updating_device: state.billboard.updating_device,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchDevices: () => dispatch(billboardActions.fetchDevices()),
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback)),
        onSelectDeviceByID: (device_id) => dispatch(billboardActions.selectDeviceByID(device_id)),
        onDeleteDevice: (device_id) => dispatch(billboardActions.deleteDevice(device_id)),
        onUpdateDevice: (device_id, attrs) => dispatch(billboardActions.updateDevice(device_id, attrs))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillboardDeviceEditView));